import { useTranslation } from "react-i18next";
import ParentDimensionsProvider from "components/charting/providers/ParentDimensionsProvider";
import ChartLoadingFallback from "components/charting/ChartLoadingFallback";
import useChartMeasureSelected from "components/charting/hooks/useChartMeasureSelected";
import useOneRepMaxSourceQueryState, {
  OneRepMaxSource,
} from "components/charting/hooks/useOneRepMaxSourceQueryState/useOneRepMaxSourceQueryState";
import OneRepMaxChartV2 from "../../OneRepMaxChart";
import OneRepMaxChartNoDataManual from "../../OneRepMaxChartNoData/components/OneRepMaxChartNoDataManual";
import OneRepMaxEntriesTable from "../../OneRepMaxEntriesTable";
import useOneRepMaxChartStatus from "../../useOneRepMaxChartStatus";
import useOneRepMaxEntries from "../../useOneRepMaxEntries";
import { OneRepMaxChartContainer } from "../OneRepMaxChartContent.components";

function OneRepMaxChartContentBody() {
  const { t } = useTranslation();
  const [oneRepMaxSource] = useOneRepMaxSourceQueryState();
  const measureSelected = useChartMeasureSelected();
  const status = useOneRepMaxChartStatus();
  const isManual = oneRepMaxSource === OneRepMaxSource.Manual;
  const entries = useOneRepMaxEntries({ enabled: isManual });

  if (status === "fetching") {
    return (
      <OneRepMaxChartContainer>
        <ChartLoadingFallback>{t("global.loading_text")}</ChartLoadingFallback>
      </OneRepMaxChartContainer>
    );
  }

  if (isManual && measureSelected && !entries.length) {
    return (
      <OneRepMaxChartContainer>
        <OneRepMaxChartNoDataManual />
      </OneRepMaxChartContainer>
    );
  }

  return (
    <>
      <OneRepMaxChartContainer>
        <ParentDimensionsProvider>
          <OneRepMaxChartV2 />
        </ParentDimensionsProvider>
      </OneRepMaxChartContainer>
      {isManual ? <OneRepMaxEntriesTable /> : null}
    </>
  );
}

export default OneRepMaxChartContentBody;
